import styled from 'styled-components';

import { Notification } from 'components/Toolkit/Notification/Notification';
import type { NotificationProps } from 'components/Toolkit/Notification/Notification.typed';

/**
 * Future improvement:
 * - Replace type with intent
 * - Replace text with children
 */
export interface ToastProps
  extends Omit<NotificationProps, 'intent' | 'children'> {
  type: NotificationProps['intent'];
  text: NotificationProps['children'];
  closeOnClick?: boolean;
  customId?: number | string;
  autoClose?: number;
}

const SNotification = styled(Notification)`
  max-width: 320px;
  // Included to account for absolute positioned close button
  padding-right: ${({ theme }) => theme.spacing.L40};
`;

export const fireToast = async ({
  type,
  text,
  hasIcon = true,
  closeOnClick = true,
  customId,
  autoClose = 5000,
  ...rest
}: ToastProps) => {
  import(/* webpackChunkName: "fireToast" */ 'react-toastify').then(
    ({ toast }) => {
      return toast(
        <SNotification hasIcon={hasIcon} intent={type} {...rest}>
          {text}
        </SNotification>,
        {
          closeOnClick,
          toastId: customId,
          autoClose,
        },
      );
    },
  );
};
